import * as React from 'react';

import Widget from './Widget';
import MeasurementWidgetContainer from '../MeasurementWidgetContainer';

interface IProps {
    widgetId: string,
}

export default class WidgetContainer extends React.Component<IProps, void> {
    static propTypes = {
        widgetId: React.PropTypes.string.isRequired,
    };

    render() {
        const requestOptions = {
            valueType: 'ALL',
            fillGaps: true,
        };

        return (
            <MeasurementWidgetContainer {...this.props} requestOptions={requestOptions} widget={Widget} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widget/listMeasurements/WidgetContainer.tsx